module.exports = __webpack_public_path__ + "static/3-003-b5e1dfded9af3ff2824a6caaad0f5ac8.mp4";